export default __webpack_public_path__ + "065b4103f7b446cb43336644cfeaff41.png";